import { render, staticRenderFns } from "./FixedAdd.vue?vue&type=template&id=b830463a&scoped=true"
import script from "./FixedAdd.vue?vue&type=script&lang=js"
export * from "./FixedAdd.vue?vue&type=script&lang=js"
import style0 from "./FixedAdd.vue?vue&type=style&index=0&id=b830463a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b830463a",
  null
  
)

export default component.exports